/* ============
 * Minimal Layout
 * ============
 *
 * Used for the register and login pages
 *
 */

export default {};



// WEBPACK FOOTER //
// ./src/app/layouts/minimal/minimal.js